// src/pages/Dashboard/useMeetingToday.js
// STATUS: active | UPDATED: 2026-09-27
// LOG:
//   2026-09-27  New. One read of this morning's meeting for a salesperson's
//               Today, shared by the routine (its one rep follows the focus)
//               and the recap (shown once the meeting is held).
//
// The whole floor may read the meeting (0040) and the store's marks (0046),
// so this is the salesperson's own session asking, not a privileged read.
//
// Everything is null until known and stays null on a failed read. The routine
// then falls back to the person's own current step, which is what it did
// before this existed, and the recap does not render.

import { useEffect, useState } from 'react'
import { getMeeting } from '../../lib/morningMeeting'
import { listSince, listPeople, yesterdaysMarks, todaysMarks } from '../../lib/recognitions'
import { dayKey, addDays, parseDay } from '../../lib/localDate'

export default function useMeetingToday(dealershipId) {
  const [meeting, setMeeting] = useState(null)
  const [calledOut, setCalledOut] = useState([])
  const [people, setPeople] = useState({})

  useEffect(() => {
    if (!dealershipId) return
    let live = true
    const today = dayKey()
    ;(async () => {
      const [m, r] = await Promise.all([
        getMeeting(dealershipId, today),
        listSince(dealershipId, parseDay(addDays(today, -1)).toISOString()),
      ])
      if (!live) return
      if (!m.error) setMeeting(m.data)
      if (!r.data) return
      // What gets called out at a morning meeting is yesterday, plus anything
      // given this morning before or during it.
      const out = [...todaysMarks(r.data, today), ...yesterdaysMarks(r.data, today)]
      setCalledOut(out)
      if (out.length) {
        const who = await listPeople(out.map((x) => x.given_to))
        if (live && who.data) setPeople(Object.fromEntries(who.data.map((u) => [u.id, u])))
      }
    })()
    return () => {
      live = false
    }
  }, [dealershipId])

  return { meeting, calledOut, people }
}
